<template>
  <v-application v-if="access.setting_open_tickets">
    <v-settings>
      <v-toolbar flat class="pt-2">
        <v-toolbar-title>{{ $t("open_tickets") }}</v-toolbar-title>
        <v-spacer />
        <v-combobox
          v-model="store"
          :label="$t('stores')"
          hide-details
          v-bind:items="stores"
          item-value="_id"
          item-text="name"
        />
      </v-toolbar>
      <v-form v-model="is_valid">
        <v-card-text>
          <draggable tag="v-list" handle=".v-list-item__icon">
            <v-list-item
              v-for="(item, index) in tickets"
              v-bind:key="index"
              v-model="item.value"
            >
              <v-list-item-icon style="margin-right: 10px">
                <v-icon>mdi-menu</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-text-field
                  v-model="item.name"
                  hide-details
                  dense
                  append-outer-icon="mdi-delete"
                  v-on:click:append-outer="remove_ticket(index)"
                  :rules="[fieldRules.required]"
                />
              </v-list-item-content>
            </v-list-item>
          </draggable>
          <v-btn text color="primary" small v-on:click="add_ticket"
            ><v-icon>mdi-plus</v-icon>{{ $t("add_predefined_ticket") }}</v-btn
          >
        </v-card-text>
      </v-form>
      <template #actions>
        <!--<v-btn text v-on:click="tickets_cancel">cancel</v-btn>-->
        <v-btn
          text
          color="primary"
          v-on:click="tickets_save"
          :disabled="!is_valid"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Tickets from "../../mixins/tickets";
export default {
  name: "SettingsTickets",
  mixins: [Tickets],
  data: () => ({
    is_valid: false,
  }),
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>